// extracted by mini-css-extract-plugin
export default {"divider":"divider_divider__xIU4D","line":"divider_line__AoqWb"};